const SquareTrinidadAndTobago = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 16">
      <g clipPath="url(#a)">
        <g clipPath="url(#b)">
          <rect width="22" height="16" fill="#AF010D" rx="2" />
          <path fill="white" fillRule="evenodd" d="M7.33333 0L22 16H14.6667L0 0H7.33333Z" clipRule="evenodd" />
          <path
            fill="#151515"
            fillRule="evenodd"
            d="M6.28595 0L20.9526 16H15.7145L1.04785 0H7.33357H6.28595Z"
            clipRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0H22V16H0z" />
        </clipPath>
        <clipPath id="b">
          <rect width="22" height="16" fill="white" rx="2" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SquareTrinidadAndTobago;
